import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Tab, Tabs } from "@mui/material";
import { useTheme } from "../../../../../context/themeContext";
import Given from "../text/components/given";
import Received from "../text/components/received";
import styles from "./style.module.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useLocalStorageState from "../../../../../hooks/useLocalStorageState";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: "1rem" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const { theme, darkMode } = useTheme();
  const {
    data: { receivedShoutouts, givenShoutouts },
  } = useSelector((state) => state.shoutouts);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const shoutoutsTabNames = ["received", "given"];
  const [sectionTab, setSectionTab] = useLocalStorageState("section-tab", 0);

  useEffect(() => {
    if (!sectionTab || sectionTab === -1) setSectionTab(0);
  }, []);

  useEffect(() => {
    const currentTab = shoutoutsTabNames.indexOf(pathname.split("/").pop());
    if (currentTab !== -1 && currentTab !== sectionTab) {
      setSectionTab(currentTab);
    }
  }, [pathname]);

  const handleChange = (event, newValue) => {
    setSectionTab(newValue);
    navigate(`/profile/shoutouts/${shoutoutsTabNames[newValue]}`);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={sectionTab === -1 ? 0 : sectionTab}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
          sx={{
            "& .MuiTab-root": {
              color: darkMode && theme.palette.darkgrey.darkgrey400,
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: darkMode && theme.palette.darkgrey.darkgrey500,
              },
            },
          }}
        >
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Received(${receivedShoutouts?.length || 0})`}
            {...a11yProps(0)}
          />
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Given(${givenShoutouts?.length || 0})`}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={sectionTab} index={0}>
        <Box className={styles.card}>
          {receivedShoutouts !== null &&
            receivedShoutouts?.map((user, index) => (
              <Box key={index} className={styles.container}>
                <Received data={user} />
              </Box>
            ))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={sectionTab} index={1}>
        <Box className={styles.card}>
          {givenShoutouts !== null &&
            givenShoutouts?.map((item, index) => (
              <Box key={index} className={styles.container}>
                {<Given data={item} />}
              </Box>
            ))}
        </Box>
      </CustomTabPanel>
    </Box>
  );
}
